// extracted by mini-css-extract-plugin
export default {"drawerNavCard":"NpRnMT97"};